var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActiveList',{attrs:{"config":_vm.config,"custom-query":{
    role: 3,
    includepartners: false,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }